import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="container">
      <div className="card">
        <div className="card-inner">
          <div className="section-title">
            <h2>页面不存在</h2>
          </div>
          <div className="row">
            <Link className="btn secondary" to="/">
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

